import { render, staticRenderFns } from "./MyRegister.vue?vue&type=template&id=77631dfc"
import script from "./MyRegister.vue?vue&type=script&lang=js"
export * from "./MyRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports